<mat-toolbar (click)="buttonClicked.emit()" color="primary">
  <button mat-button class="sidenav-toggle">
    <mat-icon>menu</mat-icon>
  </button>
  @if (activeOrg) {
    <span class="active-org">{{ activeOrg.name }}</span>
  }
</mat-toolbar>
